import objectFitImages from 'object-fit-images' ; // object-fit polyfill
import DetectIE from './DetectIE' ;

const $ = jQuery;

export default class LazyPagination {

    constructor() {
        this.selector = '[data-lazypaginate=1]';

        this.onClick = this.onClick.bind(this);
        this.onDelayedDisplay = this.onDelayedDisplay.bind(this);

        $('body').on('click touchstart', this.selector, this.onClick);
    }

    onClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const $me = $(event.currentTarget),
            targetUrl = $me.attr('href'),
            container = $($me.data('container')),
            oldPagination = $($me.data('pagination'));
        oldPagination.empty().html('<div class="loading">'+$('.loading').html()+'</div>');
        fetch( targetUrl,  {
            method: 'get'
        }).then((response) => {
            return response.text();
        }).then((response) => {
            const DOM = $(response),
                newPagination = DOM.find($me.data('container')).parent().find($me.data('pagination'));
            this.$items = DOM.find($me.data('items'));
            this.className = $me.data('items').substr(1) + '--loading';
            this.iterator = 0;
            this.$items.addClass(this.className);
            container.append(this.$items);

            // Ugly hack to fix wrongly implemented srcset/sizes <http://caniuse.com/#search=srcset>
            const $images = this.$items.find('img');
            if (DetectIE()) {
                $images.removeAttr('srcset').removeAttr('sizes');
            }

            // Init object-fit polyfill
            objectFitImages($images.get());

            // Add new pagination
            oldPagination.empty().html(newPagination.html());
            window.requestAnimationFrame(this.onDelayedDisplay);
        });
    }

    onDelayedDisplay() {
        this.$items.eq(this.iterator).removeClass(this.className);
        setTimeout(() => {
            if (++this.iterator < this.$items.length) {
                this.onDelayedDisplay();
            }
        }, 250);
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/LazyPagination.js